module.exports = __webpack_public_path__ + "img/aramex_charge_logo.2d6ffe53.png";